import { CLIENTS_ROUTE, PROSPECTS_ROUTE } from './auth';
import { ReactComponent as ClientsIcon } from '../../assets/icons/icon-clients.svg';
import { ReactComponent as ProspectsIcon } from '../../assets/icons/icon-prospects.svg';
import { INavItemConfig } from '../interfaces/globals';
import { TRANSLATIONS_GLOBAL } from '../translations/commons';

export const NAV_ITEMS: INavItemConfig[] = [
  { id: 'prospects', to: PROSPECTS_ROUTE, label: TRANSLATIONS_GLOBAL.sidebar.sections.prospects, Icon: ProspectsIcon },
  { id: 'clients', to: CLIENTS_ROUTE, label: TRANSLATIONS_GLOBAL.sidebar.sections.clients, Icon: ClientsIcon }
];
